import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import "./CommonBoard.css";

export default function BoardDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchPostAndComments = async () => {
      try {
        const resPost = await axios.get(`${baseUrl}/api/board/${id}?increase=true`); // 🔥 조회수 같이 증가
        setPost(resPost.data);
  
        const resComments = await axios.get(`${baseUrl}/api/board/${id}/comments`);
        setComments(resComments.data);
      } catch (err) {
        console.error("게시글 또는 댓글 불러오기 실패:", err);
      }
    };
  
    fetchPostAndComments();
  }, [id, baseUrl]);

  const handleCommentSubmit = (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;
    axios.post(`${baseUrl}/api/board/${id}/comments`, { content: newComment })
      .then(res => {
        setComments(prev => [...prev, res.data]);
        setNewComment("");
      })
      .catch(err => {
        console.error("댓글 등록 실패:", err);
      });
  };

  if (!post) return <div className="loading">로딩 중...</div>;

  const formatDate = (dateStr) => dayjs(dateStr).format("YYYY년 MM월 DD일");

  return (
    <div className="board-wrapper">
      <div className="board-container">
        <h1 className="board-title">게시판</h1>

        <div className="board-header">
          <h2 className="board-heading">{post.title}</h2>
          <div className="board-meta">
            관리자 | <span>{formatDate(post.date)}</span> | 조회수 {post.view_count || 0} | 댓글 {comments.length}
          </div>
        </div>

        <div className="board-divider"></div>

        <div className="board-content">
          {post.content}
        </div>

        <div className="comment-section">
          <h3 className="comment-title">댓글 {comments.length}</h3>

          <div className="comment-list">
            {comments.map((comment, index) => (
              <div key={index} className="comment-card">
                <div className="comment-content">{comment.content}</div>
                <div className="comment-date">{comment.date ? formatDate(comment.date) : "방금 전"}</div>
              </div>
            ))}
          </div>

          <form onSubmit={handleCommentSubmit} className="comment-form">
            <input
              type="text"
              className="comment-input"
              placeholder="댓글을 입력하세요"
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
            />
            <button
              type="submit"
              className="comment-button"
            >
              등록
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
